import React from "react";
import './loading-spinner.styles.scss';

const LoadingSpinner = () => {

    return (
        <div className="loading-spinner"/>
    );
};

export default LoadingSpinner;
